module.exports = __webpack_public_path__ + "static/img/image_c_strawberry.ac8d333.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/image_c_strawberry.jpg
// module id = R7fA
// module chunks = 1